import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { isAuthenticated } from '@/service/authService'


const routes = [
            {
                path: '/depositos/aguardando-dividendo',
                name: 'deposit-waiting-dividend-list',
                component: () => import('../views/deposit/DepositWaitingDividendList.vue')
            },
            {
                path: '/depositos/todos',
                name: 'all-deposits-list',
                component: () => import('../views/deposit/AllDepositsList.vue')
            },
            {
                path: '/depositos/aguardando-aprovacao',
                name: 'deposit-waiting-approval-list',
                component: () => import('../views/deposit/DepositWaitingApprovalList.vue')
            },
            {
                path: '/depositos/aguardando-pagamento',
                name: 'deposit-waiting-payment-list',
                component: () => import('../views/deposit/DepositWaitingPaymentList.vue')
            },
            {
                path: '/depositos/aprovados',
                name: 'deposit-approved-list',
                component: () => import('../views/deposit/DepositApprovedList.vue')
            },
            {
                path: '/depositos/rejeitados',
                name: 'deposit-rejected-list',
                component: () => import('../views/deposit/DepositRejectedList.vue')
            },
            {
                path: '/depositos/para-pagamentos',
                name: 'deposit-approved-ended-list',
                component: () => import('../views/deposit/DepositApprovedEndedList.vue')
            },
            {
                path: '/depositos/:investorId',
                name: 'my-deposits',
                component: () => import('../views/deposit/MyDepositList.vue'),
                props: true
            },
            {
                path: '/depositos',
                name: 'deposit-list',
                component: () => import('../views/deposit/MyDepositList.vue')
            },
            {
                path: '/devolucoes',
                name: 'refound-payment',
                component: () => import('@/views/refound/RefoundPaymentTabs.vue')
            },
            {
                path: '/devolucoes/:id',
                name: 'refound-payment-list',
                component: () => import('@/views/refound/RefoundPayment.vue'),
                props: true
            },
            {
                path: '/historico-pagamentos',
                name: 'payment-history',
                component: () => import('@/views/paymentHistory/PaymentHistory.vue')
            },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login-vue',
        component: () => import( '../views/LoginView.vue'),
        meta: { hideHeader: true }
    },
    {
        path: '/',
        name: 'login-vue',
        component: () => import( '../views/LoginView.vue'),
        meta: { hideHeader: true }
    },
    {
        path: '/investidor',
        name: 'investor-create',
        component: () => import('../views/investor/Investor.vue')
    },
    {
        path: '/investidor/:id',
        name: 'investor-edit',
        component: () => import('../views/investor/InvestorTabs.vue')
    },
    {
        path: '/investidores',
        name: 'investor-list',
        component: () => import('../views/investor/InvestorList.vue')
    },
    {
        path: "/investimentos",
        name: "investment-list",
        component: () => import('../views/investment/InvestmentList.vue')
    },
    {
        path: "/investimentos-disponiveis",
        name: "investment-catalog",
        component: () => import('../views/investment/InvestmentCatalog.vue')
    },
    {
        path: "/investimento",
        name: "investment-create",
        component: () => import("../views/investment/Investment.vue")
    },
    {
        path: "/investimento/:id",
        name: "investment-edit",
        component: () => import("../views/investment/Investment.vue"),
        props: true
    },
    {
        path: "/investimento/visualizar/:id",
        name: "investment-view",
        component: () => import("../views/investment/InvestmentView.vue"),
        props: true
    },
    {
        path: "/investimento/:id/depositos",
        name: "investment-deposits",
        component: () => import('../views/investment/InvestmentDepositsList.vue'),
        props: true
    },

    {
        path: "/avisos",
        name: "information-list",
        component: () => import('../views/information/InformationList.vue')
    },
    {
        path: "/information/new",
        name: "information-create",
        component: () => import('../views/information/InformationForm.vue')
    },
    {
        path: "/information/edit/:id",
        name: "information-edit",
        component: () => import('../views/information/InformationForm.vue'),
        props: true
    },
    {
        path: "/information/:id",
        name: "information-view",
        component: () => import('../views/information/InformationView.vue'),
        props: true
    },
    {
        path: '/deposito',
        name: 'deposit-create',
        component: () => import('../views/deposit/Deposit.vue'),
        props: route => ({
            depositInvestmentId: route.query.investmentId ?? null
        })
    },
    {
        path: '/deposito/:id',
        name: 'deposit-edit',
        component: () => import('../views/deposit/Deposit.vue'),
        props: true
    },
    {
        path: '/carteira/:investorId',
        name: 'wallet',
        component: () => import('../views/wallet/Wallet.vue'),
        props: true
    },
    {
        path: '/metricas-login/:userId/:start/:end',
        name: 'login-metrics',
        component: () => import('../views/loginMetrics/LoginMetrics.vue'),
        props: true
    },
    {
        path: '/metricas-login',
        name: 'login-metrics-base',
        component: () => import('../views/loginMetrics/LoginMetrics.vue')
    }
]

const index = createRouter({
    history: createWebHistory(),
    routes
})

index.beforeEach((to, from, next) => {
    const publicRoutes = ['login-vue']
    const isPublic = publicRoutes.includes(to.name)
    const loggedIn = isAuthenticated()

    if (!isPublic && !loggedIn) {
        next({ name: 'login-vue', query: { redirect: to.fullPath } })
    } else {
        next()
    }
})

export default index